package com.exura.pages.publicplans.orders

import com.exura.features.publicplans.domain.model.AnonymousPublicPlanOrder
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.LocalDate
import kotlinx.datetime.plus


internal fun calculateOrderStatsRanges(
    orders: List<AnonymousPublicPlanOrder>,
    sortedRanges: List<Pair<LocalDate, LocalDate>>,
): List<OrderStats> {

    if (sortedRanges.isEmpty()) return emptyList()

    val statsList = sortedRanges.map { OrderStats(date = it.first) }.toMutableList()
    val rangeEnds = sortedRanges.map { it.second }

    val graphStart = sortedRanges.first().first
    val graphEnd = sortedRanges.last().second

    for (order in orders) {
        val accessDate = order.accessedDate.date
        val anchor = order.anchorDate.date
        val start: LocalDate
        val end: LocalDate

        if (order.orderDuration >= 0) {
            start = anchor
            end = anchor.plus(DatePeriod(days = order.orderDuration))
        } else {
            start = anchor.plus(DatePeriod(days = order.orderDuration))
            end = anchor
        }

        val isAccessRelevant = accessDate in graphStart..graphEnd
        val isOrderOverlap = start <= graphEnd && end >= graphStart

        if (!isAccessRelevant && !isOrderOverlap) continue

        if (isAccessRelevant) bumpIndex(
            findRangeIndex(
                sortedRanges,
                rangeEnds,
                accessDate
            )
        ) { statsList[it].accessedCount++ }

        if (start in graphStart..graphEnd) {
            bumpIndex(findRangeIndex(sortedRanges, rangeEnds, start)) { statsList[it].startedCount++ }
        }

        if (end in graphStart..graphEnd) {
            bumpIndex(findRangeIndex(sortedRanges, rangeEnds, end)) { statsList[it].endedCount++ }
        }

        if (isOrderOverlap) {
            var idx = rangeEnds.binarySearch(start)
            if (idx < 0) idx = -idx - 1

            while (idx < sortedRanges.size) {
                val range = sortedRanges[idx]

                if (range.first > end) break

                statsList[idx].inProgressCount++
                idx++
            }
        }
    }

    return statsList
}

private inline fun bumpIndex(index: Int, block: (Int) -> Unit) {
    if (index != -1) block(index)
}

private fun findRangeIndex(
    ranges: List<Pair<LocalDate, LocalDate>>,
    rangeEnds: List<LocalDate>,
    date: LocalDate
): Int {
    var idx = rangeEnds.binarySearch(date)
    if (idx < 0) idx = -idx - 1

    if (idx >= ranges.size) return -1

    return if (date >= ranges[idx].first) idx else -1
}
